module.exports = __webpack_public_path__ + "img/Folder-Icon.611a6032.svg";